export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950">
      <div className="px-4 md:px-6 pt-14 md:pt-20 pb-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10 mb-10 md:mb-14">
            <div>
              <a href="#hero" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 bg-accent-500 rounded-lg flex items-center justify-center">
                  <i className="ri-flashlight-line text-white text-lg w-5 h-5 flex items-center justify-center"></i>
                </div>
                <span className="text-white font-bold text-lg font-heading">爆料网</span>
              </a>
              <p className="text-secondary-400 text-sm leading-relaxed">
                爆料网是全网领先的娱乐热点与爆料内容聚合平台。我们整合911爆料网、51爆料网、91爆料网等平台的一手资源，
                为吃瓜群众提供最及时、最全面的独家爆料追踪。一手猛料不打烊，掌握今日大瓜不迷路。
              </p>
            </div>

            <div>
              <h3 className="text-background-200 font-semibold text-sm uppercase tracking-wider mb-4">快速链接</h3>
              <nav className="flex flex-col gap-2.5">
                <a href="#carousel" className="text-secondary-400 hover:text-background-100 text-sm transition-colors">焦点专题</a>
                <a href="#media" className="text-secondary-400 hover:text-background-100 text-sm transition-colors">吃瓜视频</a>
                <a href="#cards" className="text-secondary-400 hover:text-background-100 text-sm transition-colors">独家猛料</a>
                <a href="#ranking" className="text-secondary-400 hover:text-background-100 text-sm transition-colors">热度榜单</a>
              </nav>
            </div>

            <div>
              <h3 className="text-background-200 font-semibold text-sm uppercase tracking-wider mb-4">关注我们</h3>
              <div className="flex items-center gap-3">
                <a href="#footer" className="w-9 h-9 rounded-full bg-background-800 hover:bg-accent-500 flex items-center justify-center transition-colors">
                  <i className="ri-weibo-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a href="#footer" className="w-9 h-9 rounded-full bg-background-800 hover:bg-accent-500 flex items-center justify-center transition-colors">
                  <i className="ri-wechat-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a href="#footer" className="w-9 h-9 rounded-full bg-background-800 hover:bg-accent-500 flex items-center justify-center transition-colors">
                  <i className="ri-telegram-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-background-200 font-semibold text-sm uppercase tracking-wider mb-4">合作伙伴</h3>
              <p className="text-secondary-400 text-sm">诚邀优质平台与品牌合作</p>
              <a href="#contact" className="inline-block mt-3 text-accent-400 hover:text-accent-300 text-sm font-medium transition-colors">
                联系合作 →
              </a>
            </div>
          </div>

          <div className="py-10 md:py-14">
            <div className="text-center">
              <span className="text-[clamp(3rem,10vw,10rem)] font-black text-background-800/30 font-label leading-none select-none tracking-tighter">
                BAOLIAO
              </span>
            </div>
          </div>

          <div className="border-t border-white/5 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-secondary-500 text-xs">
              &copy; 2026 爆料网. 本站内容仅供信息参考，不构成任何建议。
            </p>
            <div className="flex items-center gap-4">
              <a href="#faq" className="text-secondary-500 hover:text-background-200 text-xs transition-colors">隐私政策</a>
              <a href="#faq" className="text-secondary-500 hover:text-background-200 text-xs transition-colors">投稿规则</a>
              <a href="#contact" className="text-secondary-500 hover:text-background-200 text-xs transition-colors">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}